import React from 'react';

import SvgContainer from '../SvgContainer';

const Check = () => {
    return (
        <SvgContainer>
            <path d="M5.09091 11.7836L1.9504 8.43214C1.58347 8.04057 0.961988 8.04057 0.595055 8.43214C0.260345 8.78933 0.260346 9.345 0.595055 9.70219L4.36121 13.7213C4.75631 14.1429 5.4255 14.1429 5.82061 13.7213L15.4049 3.49323C15.7397 3.13604 15.7397 2.58038 15.4049 2.22319C15.038 1.83161 14.4165 1.83161 14.0496 2.22319L5.09091 11.7836Z" />
        </SvgContainer>
    );
};

export default Check;
